export { UploaderModule } from './uploader.module';
export { UploaderService } from './uploader.service';
export { UploaderOptions } from './uploader-options.model';



// WEBPACK FOOTER //
// /dist/src/app/uploader/index.ts